import { makeStyles, tokens, Tree, TreeItem, TreeItemLayout } from '@fluentui/react-components';
import { Link } from 'react-router-dom';

export type TDisplayItem = {
  id: string;
  text: string;
  duplicateId?: string;
  href?: string;
  onClick?: () => void;
};

type TProps = {
  displayItems: TDisplayItem[];
  isSideBar: boolean;
};

const useStyle = makeStyles({
  item: {
    paddingLeft: tokens.spacingHorizontalS,
    overflow: 'hidden',
  },
  itemSideBar: {
    paddingLeft: tokens.spacingHorizontalXL,
    overflow: 'hidden',
  },
  // TreeItem defaults to `cursor: pointer` for every leaf; override for rows with no action.
  nonClickable: {
    cursor: 'default',
  },
});

const ItemList = ({ displayItems, isSideBar }: TProps) => {
  const classes = useStyle();

  // Add number for duplicate names:
  /*
  displayItems = useMemo(() => {
    const counter: TMap<string, number> = { };
    return displayItems.map(displayItem => {
      const duplicateId = displayItem.duplicateId || displayItem.text;
      const count = counter[duplicateId] = (counter[duplicateId] || 0) + 1;
      return {
        ...displayItem,
        text: displayItem.text + (count > 1 ? ` (${count})` : '')
      };
    });
  }, [displayItems]);
  */

  if (displayItems.length <= 0) return <p className="pl-3">Nothing found.</p>;

  return (
    <Tree size="small" aria-label="Items list">
      {displayItems.map((displayItem) => {
        const isClickable = !!displayItem.href || !!displayItem.onClick;
        // Inline style on the innermost text span - bypasses Fluent's internal TreeItemLayout
        // color rules that win over an outer className via descendant specificity.
        const textColor = isClickable ? tokens.colorBrandForeground2 : tokens.colorNeutralForeground1;
        const item = (
          <TreeItem
            key={displayItem.id}
            itemType="leaf"
            onClick={displayItem.onClick}
            className={isClickable ? undefined : classes.nonClickable}
          >
            <TreeItemLayout className={isSideBar ? classes.itemSideBar : classes.item}>
              <span style={{ color: textColor }}>{displayItem.text}</span>
            </TreeItemLayout>
          </TreeItem>
        );
        return displayItem.href ? (
          <Link key={displayItem.id} target="_blank" to={displayItem.href}>
            {item}
          </Link>
        ) : (
          item
        );
      })}
    </Tree>
  );
};

export { ItemList };
